import DocumentPage from "../../../../invoice/DocumentPage";
import { siiReplacementInvoiceConfig } from "./config";

const SIIReplacementInvoice = () => (
  <DocumentPage config={siiReplacementInvoiceConfig} />
);

export default SIIReplacementInvoice;
